<header>
    <div class="container">
      <a routerLink="cart" class=" cart-icon" *ngIf="currentdata">Cart 
        <i class="fas fa-cart-plus"></i><span class="bg-danger count text-white">0</span></a>

      <div class="btn-group" mdbDropdown *ngIf="!currentdata">
        <ul class="list-inline" mdbDropdownToggle>
          <!-- <li class="list-inline-item"><mdb-icon  fas icon="user"></mdb-icon></li> -->
          <li class="list-inline-item"><i class="fa fa-user"></i></li>                                
          <li class="list-inline-item font-weight-bold">Register</li>
          <li class="list-inline-item"><i class="fa fa-angle-down"></i></li>                                
        </ul>
        <div class="dropdown-menu dropdown-menu-right dropdown-primary">
          <a class="dropdown-item" routerLink="register">Sign up</a>
          <a class="dropdown-item" routerLink="login">Log in</a>
  
        </div>
      </div>
      
      <div class="btn-group" mdbDropdown *ngIf="currentdata">
        <ul class="list-inline" mdbDropdownToggle>
          <!-- <li class="list-inline-item"><mdb-icon  fas icon="user"></mdb-icon></li> -->
          <li class="list-inline-item"><i class="fa fa-user"></i></li>                                
          <li class="list-inline-item font-weight-bold">{{currentdata.name}}</li>
          <li class="list-inline-item"><i class="fa fa-angle-down"></i></li>                                
        </ul>
        <div class="dropdown-menu dropdown-menu-right dropdown-primary">
          <a class="dropdown-item" routerLink="/profile">Edit profile</a>
          <a class="dropdown-item" (click)="logout()" >Log out</a>
        </div>
      </div>    
    </div>
  </header>
  <div class="clearfix"></div>
  
  <!--Navbar-->
  <mdb-navbar class="bg-wa py-3" SideClass="navbar navbar-expand-lg navbar-dark bg-wa font-weight-bold py-3" [containerInside]="true">
  
      <!-- Navbar brand -->
      <mdb-navbar-brand><a class="navbar-brand" href="#">HOMY SHOP</a></mdb-navbar-brand>
    
      <!-- Collapsible content -->
      <links>
    
        <!-- Links -->
        <ul class="navbar-nav m-auto">
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link waves-light" routerLink="home" mdbWavesEffect>Home<span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link waves-light" routerLink="about" mdbWavesEffect>About</a>
          </li>

    
    
          <!-- Dropdown -->
          <!-- <li class="nav-item dropdown" dropdown>
            <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>
              Basic dropdown<span class="caret"></span></a>
            <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
              <a class="dropdown-item waves-light" mdbWavesEffect href="#">Action</a>
              <a class="dropdown-item waves-light" mdbWavesEffect href="#">Another action</a>
              <a class="dropdown-item waves-light" mdbWavesEffect href="#">Something else here</a>
              <div class="divider dropdown-divider"></div>
              <a class="dropdown-item waves-light" mdbWavesEffect href="#">Separated link</a>
            </div>
          </li> -->
          <li class="collapse navbar-collapse" id="navbar">
              <ul class="navbar-nav mr-auto">
               <li class="nav-item dropdown megamenu-li">
                <a class="nav-link dropdown-toggle" href="" id="dropdown01" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Mega Menu 1</a>
                <div class="dropdown-menu megamenu" aria-labelledby="dropdown01">
                 <div class="row">
                  <div class="col-sm-6 col-lg-3">
                   <h5>Links</h5>
                   <a class="dropdown-item" href="#">Another action</a>
                   <a class="dropdown-item" href="#">Something else here</a>
                   <a class="dropdown-item" href="#">Another action</a>
                   <a class="dropdown-item" href="#">Something else here</a>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                   <h5>More Links</h5>
                   <a class="dropdown-item" href="#">Another action</a>
                   <a class="dropdown-item" href="#">Something else here</a>
                   <a class="dropdown-item" href="#">Another action</a>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                   <h5>Paragraph</h5>
                   <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus in veritatis, facilis eligendi sunt, culpa autem harum porro earum.</p>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                   <h5>Image</h5>
                   <img src="https://source.unsplash.com/250x150/?sig=4" alt="..." style="width: 100%;">
                  </div>
                 </div>
                </div>
               </li>
               <li class="nav-item dropdown megamenu-li">
                <a class="nav-link dropdown-toggle" href="" id="dropdown02" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Mega Menu 2</a>
                <div class="dropdown-menu megamenu" aria-labelledby="dropdown02">
                 <div class="row">
                  <div class="col-sm-6 col-lg-4">
                   <h5>Image Slider</h5>
                   <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner">
                     <div class="carousel-item active">
                      <img class="d-block w-100" src="https://source.unsplash.com/250x150/?sig=1" alt="...">
                     </div>
                     <div class="carousel-item">
                      <img class="d-block w-100" src="https://source.unsplash.com/250x150/?sig=2" alt="...">
                     </div>
                     <div class="carousel-item">
                      <img class="d-block w-100" src="https://source.unsplash.com/250x150/?sig=3" alt="...">
                     </div>
                    </div>
                   </div>
                  </div>
                  <div class="col-sm-6 col-lg-3">
                   <h5>Links</h5>
                   <a class="dropdown-item" href="#">Another action</a>
                   <a class="dropdown-item" href="#">Something else here</a>
                   <a class="dropdown-item" href="#">Another action</a>
                   <a class="dropdown-item" href="#">Something else here</a>
                  </div>
                  <div class="col-sm-6 col-lg-5">
                   <h5>Paragraph</h5>
                   <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Veniam impedit itaque minus distinctio possimus reiciendis et repellat. Voluptate, temporibus veniam et praesentium alias, maxime repudiandae aliquid, natus omnis animi iste!</p>
                  </div>
                 </div>
                </div>
               </li>
              </ul>
            </li>
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link waves-light" routerLink="contact" mdbWavesEffect>Contact</a>
            </li>                
        </ul>
        <!-- Links -->
      
  
      </links>
      <!-- Collapsible content -->
      
    
    </mdb-navbar>
  